import type { ReactNode } from 'react';

/**
 * PageHeader
 * --------------------------------
 * 视图大标题组件。统一标题字号 20 / 副标题 13 / 间距 16。
 */
export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
}

export function PageHeader({ title, subtitle, extra }: PageHeaderProps) {
  return (
    <div className="up-page__header">
      <div>
        <div className="up-page__title">{title}</div>
        {subtitle ? <div className="up-page__subtitle">{subtitle}</div> : null}
      </div>
      {extra ? <div>{extra}</div> : null}
    </div>
  );
}
